'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SellPageLinks = exports.mapStateToProps = exports.SellPageLinksUnwrapped = exports.LINK_ORDERS = exports.LINKS = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _Media = require('decorators/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _decorator = require('helpers/decorator');

var _deep = require('helpers/deep');

var _optimizely = require('helpers/optimizely');

var OptimizelyUtil = _interopRequireWildcard(_optimizely);

var _verify = require('helpers/verify');

var _optimizely2 = require('vendors/Optimizely/optimizely.saga');

var OptimizelySaga = _interopRequireWildcard(_optimizely2);

var _GiftLink = require('./GiftLink');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_AFTER_MOUSELEAVE_TIME = 750;

var LINKS = exports.LINKS = {
  blog: _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      'a',
      { href: '/blog', target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.link.blog', defaultMessage: 'Blog' })
    )
  ),
  community: _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      'a',
      { href: '/blog', target: '_blank', rel: 'noopener noreferrer' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.link.community', defaultMessage: 'Community' })
    )
  ),
  features: _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/features' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.link.features', defaultMessage: 'How it works' })
    )
  ),
  fitness: _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/fitness' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.link.fitness', defaultMessage: 'Why studio fitness' })
    )
  ),
  gift: _react2.default.createElement(_GiftLink.GiftLink, null),
  locations: _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/locations' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.link.locations', defaultMessage: 'Locations' })
    )
  ),
  pricing: _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/pricing' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.link.pricing', defaultMessage: 'Pricing' })
    )
  ),
  search: _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/search' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'header.link.explore', defaultMessage: 'Explore studios' })
    )
  )
};

var LINK_ORDERS = exports.LINK_ORDERS = {
  DEFAULT: ['fitness', 'search', 'features', 'pricing', 'gift', 'community'],
  DEFAULT_TEST: ['locations', 'search', 'features', 'pricing', 'blog'],
  SEARCH: ['pricing', 'features', 'fitness', 'search', 'gift', 'community'],
  SEARCH_TEST: ['locations', 'pricing', 'features', 'search', 'blog'],
  VENUE_DETAIL: ['pricing', 'search', 'features', 'fitness', 'gift', 'community'],
  VENUE_DETAIL_TEST: ['locations', 'pricing', 'search', 'features', 'blog']
};

var SellPageLinksUnwrapped = exports.SellPageLinksUnwrapped = function (_Component) {
  (0, _inherits3.default)(SellPageLinksUnwrapped, _Component);

  function SellPageLinksUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, SellPageLinksUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = SellPageLinksUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(SellPageLinksUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = { dropdownOpen: false }, _this2.handleMouseLeave = function () {
      return _this.timer = setTimeout(_this.toggleDropdown, CLOSE_AFTER_MOUSELEAVE_TIME);
    }, _this2.handleMouseEnter = function () {
      var dropdownOpen = _this.state.dropdownOpen;


      clearTimeout(_this.timer);

      if (!dropdownOpen) {
        _this.toggleDropdown();
      }
    }, _this2.toggleDropdown = function () {
      return _this.setState(function (state) {
        return {
          dropdownOpen: !state.dropdownOpen
        };
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(SellPageLinksUnwrapped, [{
    key: 'renderLink',
    value: function renderLink(name) {
      var link = LINKS[name];
      return link && _react2.default.createElement(
        _react.Fragment,
        { key: name },
        link
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          collapsedLinks = _props.collapsedLinks,
          spreadLinks = _props.spreadLinks;
      var dropdownOpen = this.state.dropdownOpen;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        spreadLinks.map(this.renderLink),
        !(0, _verify.isEmpty)(collapsedLinks) && _react2.default.createElement(
          'li',
          {
            className: 'header__dropdown',
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
          },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)({
                header__dropdown__target: true,
                'header__dropdown__target--open': dropdownOpen
              })
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, { tagName: 'strong', id: 'nav.more', defaultMessage: 'More' }),
            _react2.default.createElement(_reactInlinesvg2.default, {
              className: 'header__dropdown__arrow svg ml-',
              uniquifyIDs: false,
              src: require('../../../../static/img/arrow.svg')
            })
          ),
          dropdownOpen && _react2.default.createElement(
            'div',
            { className: 'header__dropdown__panel' },
            _react2.default.createElement(
              'ul',
              null,
              collapsedLinks.map(this.renderLink)
            )
          )
        )
      );
    }
  }]);
  return SellPageLinksUnwrapped;
}(_react.Component);

SellPageLinksUnwrapped.propTypes = {
  collapsedLinks: _propTypes2.default.arrayOf(_propTypes2.default.oneOf((0, _keys2.default)(LINKS))).isRequired,
  spreadLinks: _propTypes2.default.arrayOf(_propTypes2.default.oneOf((0, _keys2.default)(LINKS))).isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, props) {
  var isSearchPage = props.isSearchPage,
      isVenueDetailPage = props.isVenueDetailPage,
      mediaQueryLg = props.mediaQueryLg,
      mediaQueryXl = props.mediaQueryXl;


  var experiment = (0, _deep.deepExtract)('optimizely.navLinks', (0, _universalConfig2.default)(), {});
  var links = OptimizelySaga.isAvailable(state) && OptimizelyUtil.isActiveVariationById(experiment.id, experiment.variationId) ? isSearchPage && LINK_ORDERS.SEARCH_TEST || isVenueDetailPage && LINK_ORDERS.VENUE_DETAIL_TEST || LINK_ORDERS.DEFAULT_TEST : isSearchPage && LINK_ORDERS.SEARCH || isVenueDetailPage && LINK_ORDERS.VENUE_DETAIL || LINK_ORDERS.DEFAULT;

  var shouldCollapseLinks = mediaQueryLg && (isSearchPage || isVenueDetailPage);
  var spreadCount = shouldCollapseLinks ? mediaQueryXl && 2 || mediaQueryLg && 1 || 0 : links.length;

  return {
    collapsedLinks: links.slice(spreadCount),
    spreadLinks: links.slice(0, spreadCount)
  };
};

var SellPageLinks = exports.SellPageLinks = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), _Media2.default, (0, _decorator.withName)('SellPageLinks'))(SellPageLinksUnwrapped);